import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery,Skeleton, } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";
import acc4_eng from "../../assets/acc4_eng.png"; // Adjust the path as necessary
import acc4_spa from "../../assets/acc4_spa.png"; // Adjust the path
import i18next from "i18next";
import { BASE_URL } from "../../components/BASE_URL";
const MessagesSection = () => {
    const { t ,i18n} = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

     const [loadingMessages, setLoadingMessages] = useState(true);
  const [messagesCardData, setMessagesCardData] = useState(null);

  const parseFeatureNames = (list) => {
    try {
      const items = Array.isArray(list)
        ? list
        : list
          ? JSON.parse(list)
          : [];
      return items.map((f) => f.name);
    } catch {
      return [];
    }
  };

useEffect(() => {
  const fetchMessagingHub = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Messaging_Hub`
      );
      const json = await res.json();
      if (!json.error && json.data?.length) {
        const section = json.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        if (item) {
          setMessagesCardData({
            title: item.title,
            description: item.description,
            features: parseFeatureNames(item.list),
          });
        }
      }
    } catch (err) {
      console.error("Error fetching Messaging_Hub:", err);
    } finally {
      setLoadingMessages(false);
    }
  };

  fetchMessagingHub();
}, [i18n.language]);

    return (
     <Box id="messages-section">
      {loadingMessages ? (
        <Box sx={{ p: 3 }}>
          <Skeleton variant="text" width={300} height={50} />
          <Skeleton variant="text" width={520} height={28} />
          <Skeleton variant="rectangular" width="100%" height={180} sx={{ mt: 2 }} />
        </Box>
      ) : (
        <FeaturesHeroCard
          bgColor="#FFFFFF"
          image={i18next.language === "es" ? acc4_spa : acc4_eng}
          imagePosition="right"
          title={messagesCardData?.title}
          description={messagesCardData?.description}
          features={messagesCardData?.features}
        />
      )}
    </Box>
    );
};

export default MessagesSection;






